import type { ApprovalOption } from '../components/ComparisonTabs'

interface DealCubeHistoryDetailBase {
  level?: string | number | null
  approversByLevel?: Array<{
    roleTitle: string
    decisionReasonCode: string
  }>
}

export const getApprovalOptions = (
  dealCubeHistoryDetails: DealCubeHistoryDetailBase[]
): ApprovalOption[] => {
  const options: ApprovalOption[] = []

  dealCubeHistoryDetails.forEach((detail) => {
    if (!detail || detail.level === undefined || detail.level === null) return

    const firstApprover = detail.approversByLevel?.[0]
    if (!firstApprover) return

    const level = String(detail.level).trim()
    const { decisionReasonCode, roleTitle } = firstApprover

    options.push({
      id: `${level}-${decisionReasonCode}`,
      label: `${decisionReasonCode} - ${roleTitle}`,
    })
  })

  return options
}
